import { useEffect, useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

// Module-level cache so we don't hammer the endpoint on every mount
let _cache = null;
let _cacheTime = 0;
let _inflight = null;

export const fetchFeatureFlags = async () => {
  const now = Date.now();
  if (_cache && now - _cacheTime < 60_000) return _cache;
  if (_inflight) return _inflight;
  _inflight = axios.get(`${API_URL}/public/feature-flags`)
    .then(r => {
      _cache = r.data?.flags || {};
      _cacheTime = Date.now();
      _inflight = null;
      return _cache;
    })
    .catch(() => {
      _inflight = null;
      return {};
    });
  return _inflight;
};

export const useFeatureFlag = (flag) => {
  const [enabled, setEnabled] = useState(false);
  useEffect(() => {
    let alive = true;
    fetchFeatureFlags().then(f => { if (alive) setEnabled(!!f[flag]); });
    return () => { alive = false; };
  }, [flag]);
  return enabled;
};
